import request from "@/utils/request";

export function saveShopApply(params) {
  return request({
    url: "/api/system/shopApply/saveShopApply",
    method: "post",
    data: params
  });
}

export function getShopApply(params) {
  return request({
    url: "/api/system/shopApply/getShopApply",
    method: "post",
    data: params
  });
}

export function isAudit(params) {
  return request({
    url: "/api/system/shopApply/isAudit",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/mine/cnter.js